import withThemeOverride from "../../../../utils/with-theme-override";
import clxs from "./lohono-black.module.css";

const withLohonoBlackTheme = withThemeOverride(clxs.theme);

export default withLohonoBlackTheme;
